import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Button,
  Typography,
  MenuItem,
  Select,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import FixedExpenseForm from "./FixedExpenseform";
import { PulseLoader } from "react-spinners"; // Importing the loader
import { FixedExpenseColumns } from "../../../data/DynamicTable/Collumns";
import { allFixedEntriesView } from "../../../data/Axios/queries";
import { salesManagement } from "../../../config";


const base_url = salesManagement.uri;

// State to store total expenses

// Fetch fixed expenses from backend (assuming you have a query to fetch them)
// const { data, loading, error } = useQuery(fetchFixedExpensesData, {
//   variables: { companyId },
// });

// useEffect(() => {
//   if (data && data.fixedExpenses) {
//     setFixedExpenses(data.fixedExpenses);

//     // Calculate total expenses
//     const total = data.fixedExpenses.reduce(
//       (sum, expense) => sum + parseFloat(expense.amount || 0),
//       0
//     );
//     setTotalExpenses(total);
//   }
// }, [data]);

const actions = {
  entity: "FixedExpenses",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Activate/Deactivate",
    inputObjectName: "bulkActivateDeactivateFixedEntries",
    modelName: "fixedEntryIds",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Fixed Expense Details",
    forceShowFields: ["createdBy", "updatedBy"]
  },
};
const FixedExpenses = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const [fixedExpenses, setFixedExpenses] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  return (
    <Box m="20px">

      {/* Total Fixed Expenses Section
      <Box mb="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Total Fixed Expenses: </Typography>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Typography color="error">Error loading total expenses</Typography>
        ) : (
          <Typography variant="h6">${totalExpenses.toFixed(2)}</Typography>
        )}
      </Box> */}
      <>
        <DynamicTable
          title="Fixed Expenses"
          subtitle="Manage Fixed Expenses"
          //columns={FixedExpenseColumns}
          FormComponent={FixedExpenseForm}
          query={allFixedEntriesView}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
};

export default FixedExpenses;
